import React from 'react'
import { Button } from 'reactstrap'
import { SettingsIcon } from 'config/icons'
import { FormattedMessage } from 'react-intl'

export const SettingsButton = props => {
  const { onClick, label, labelKey, className = '' } = props
  return (
    <Button tabIndex={-1} onClick={onClick} color={'outline-primary'} className={className}>
      <SettingsIcon style={{ fontSize: 16 }} /> {labelKey && <FormattedMessage id={labelKey} />}
      {label}
    </Button>
  )
}
